export default __webpack_public_path__ + "static/media/183.2ecb62cc.gif";